import { motion, MotionProps } from "framer-motion"
import React from "react"

import { NumberFont } from "../RootLayout/fonts"

export function BotegaFlow(props: MotionProps) {
  return (
    <motion.svg
      width="200"
      height="324"
      viewBox="0 0 100 162"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        //  marginTop: 8,
        marginBottom: -28,
        marginTop: -15,
      }}
      variants={{
        rest: { opacity: 0 },
        show: { opacity: 1 },
      }}
      {...props}
    >
      <path
        d="M21.0453 77L56.4396 77M21.0453 77L21.0453 62L8.50617e-06 62M21.0453 77L21.0453 91.5L1.0702e-05 91.5M125.315 77L56.4396 77M56.4396 77L56.4396 33L21.0453 33M56.4396 77L56.4396 120L21.0453 120M21.0453 33L21.0453 16.5L0 16.5M21.0453 33L21.0453 46.5L7.63376e-06 46.5M21.0453 120L21.0453 106.5L7.18516e-06 106.5M21.0453 120L21.0453 132L1.39353e-05 132"
        stroke="var(--mui-palette-enhanced-main)"
        strokeDasharray="2 2"
      />
      <motion.rect
        width="5"
        height="5"
        fill="#11EA0D"
        variants={{
          rest: { y: 14, x: -5 },
          show: {
            y: [14, 14, 30, 30, 74, 74],
            x: [-5, 19, 19, 54, 54, 100],
            transition: {
              duration: 1.5,
              ease: "linear",
              repeat: Infinity,
              repeatDelay: 2,
              delay: 1,
            },
          },
        }}
      />
      <motion.rect
        width="5"
        height="5"
        fill="#11EA0D"
        variants={{
          rest: { y: 44, x: -5 },
          show: {
            y: [44, 44, 30, 30, 74, 74],
            x: [-5, 19, 19, 54, 54, 100],
            transition: {
              duration: 1.25,
              ease: "linear",
              delay: 2.8,
              repeat: Infinity,
              repeatDelay: 2,
            },
          },
        }}
      />
      <motion.text
        style={{
          fontSize: "6px",
          fontWeight: "700",
          fill: "var(--mui-palette-text-primary)",
          fontFamily: NumberFont,
        }}
        variants={{
          rest: { y: 64, x: -15 },
          show: {
            y: [64, 64, 79, 79, 79],
            x: [-15, 18, 18, 53, 100],
            transition: {
              duration: 1.5,
              ease: "linear",
              repeat: Infinity,
              repeatDelay: 2,
              delay: 2,
            },
          },
        }}
      >
        {(Math.random() * 100).toFixed(0)}
      </motion.text>
      <motion.text
        style={{
          fontSize: "6px",
          fontWeight: "700",
          fill: "var(--mui-palette-text-primary)",
          fontFamily: NumberFont,
        }}
        variants={{
          rest: { y: 64, x: -15 },
          show: {
            y: [64, 64, 79, 79, 79],
            x: [-15, 18, 18, 53, 100],
            transition: {
              duration: 1.5,
              ease: "linear",
              repeat: Infinity,
              repeatDelay: 2,
              delay: 3,
            },
          },
        }}
      >
        {(Math.random() * 100).toFixed(0)}
      </motion.text>
      <motion.text
        style={{
          fontSize: "6px",
          fontWeight: "700",
          fill: "var(--mui-palette-text-primary)",
          fontFamily: NumberFont,
        }}
        variants={{
          rest: { y: 94, x: -15 },
          show: {
            y: [94, 94, 79, 79, 79],
            x: [-15, 18, 18, 53, 100],
            transition: {
              duration: 1.5,
              ease: "linear",
              repeat: Infinity,
              repeatDelay: 2,
              delay: 1,
            },
          },
        }}
      >
        {(Math.random() * 100).toFixed(0)}
      </motion.text>
      <motion.text
        style={{
          fontSize: "6px",
          fontWeight: "700",
          fill: "var(--mui-palette-text-primary)",
          fontFamily: NumberFont,
        }}
        variants={{
          rest: { y: 94, x: -15 },
          show: {
            y: [94, 94, 79, 79, 79],
            x: [-15, 18, 18, 53, 100],
            transition: {
              duration: 1.5,
              ease: "linear",
              repeat: Infinity,
              repeatDelay: 2,
              delay: 1.5,
            },
          },
        }}
      >
        {(Math.random() * 100).toFixed(0)}
      </motion.text>
      <motion.rect
        width="5"
        height="5"
        fill="#11EA0D"
        variants={{
          rest: { y: 104, x: -5 },
          show: {
            y: [104, 104, 118, 118, 74, 74],
            x: [-5, 19, 19, 54, 54, 100],
            transition: {
              duration: 1.5,
              ease: "linear",
              repeat: Infinity,
              repeatDelay: 2,
              delay: 1.5,
            },
          },
        }}
      />
      <motion.rect
        width="5"
        height="5"
        fill="#11EA0D"
        variants={{
          rest: { y: 104, x: -5 },
          show: {
            y: [104, 104, 118, 118, 74, 74],
            x: [-5, 19, 19, 54, 54, 100],
            transition: {
              duration: 1.5,
              ease: "linear",
              repeat: Infinity,
              repeatDelay: 2,
              delay: 2.2,
            },
          },
        }}
      />
      <motion.rect
        width="5"
        height="5"
        fill="#11EA0D"
        variants={{
          rest: { y: 129, x: -5 },
          show: {
            y: [129, 129, 118, 118, 74, 74],
            x: [-5, 19, 19, 54, 54, 100],
            transition: {
              duration: 1.5,
              ease: "linear",
              repeat: Infinity,
              repeatDelay: 2,
              delay: 1.2,
            },
          },
        }}
      />
      <motion.rect
        width="5"
        height="5"
        fill="#11EA0D"
        variants={{
          rest: { y: 129, x: -5 },
          show: {
            y: [129, 129, 118, 118, 74, 74],
            x: [-5, 19, 19, 54, 54, 100],
            transition: {
              duration: 1.25,
              ease: "linear",
              repeat: Infinity,
              repeatDelay: 2,
              delay: 3.2,
            },
          },
        }}
      />
    </motion.svg>
  )
}
